export interface UnsavedOrganization {
  readonly name: string;
  readonly locations: readonly string[];
  readonly visibleOrganizations: readonly string[];
}

export interface Organization extends UnsavedOrganization {
  readonly customers: readonly string[];
  readonly linkGuid: string;
  readonly stripeSubscription: string | null;
  readonly stripeCustomerId: string | null;
  readonly guid: string;
}

/**
 * These correspond to manually specified lookup keys which are set in the Stripe Dashboard.
 * Stripe Dashboard test environment: https://dashboard.stripe.com/test/products?active=true
 * Stripe Dashboard live environment: https://dashboard.stripe.com/products?active=true
 */
export const stripePriceLookupKeys: readonly string[] = [
  'individual-estimator-monthly',
  'individual-estimator-yearly',
  'individual-designer-monthly',
  'individual-designer-yearly',
];
export type StripePriceLookupKey = (typeof stripePriceLookupKeys)[number];

export interface ApiAuthorization {
  readonly guid: string;
  readonly userEmail: string;
  readonly userProvidedName: string;
  readonly createdAt: string;
  readonly lastUsedAt: string;
  readonly approved: boolean;
  readonly revoked: boolean;
}

export interface RevocableStandaloneToken {
  readonly guid: string;
  readonly organization: string;
  readonly claims: object;
  readonly createdAt: string;
  readonly createdBy: string;
}

export interface ExternalWebhook {
  readonly guid: string;
  readonly organization: string;
  readonly userProvidedName: string | null;
  readonly createdAt: string;
  readonly externalWebhookUrl: string;
  readonly secretToken: string | null;
}
